export const ConnectWalletIcon = (props: any) => {
  return (
    <div {...props}>
      <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.8135 0.544974C12.1919 0.474172 12.5812 0.487089 12.9541 0.58286C13.3299 0.679359 13.6797 0.857599 13.9786 1.10486C14.2776 1.35212 14.5182 1.66232 14.6835 2.01331C14.8487 2.36429 14.9345 2.74743 14.9346 3.13537V3.88805C16.0278 4.18129 16.8327 4.76239 16.8327 5.94813V12.8712C16.8327 14.2873 15.6847 15.4353 14.2686 15.4353H2.73012C1.314 15.4353 0.166016 14.2873 0.166016 12.8712V6.52506V5.94813V4.75848C0.165732 4.14483 0.379533 3.55005 0.770579 3.07712C1.16174 2.60405 1.70574 2.28231 2.30873 2.1674C2.31399 2.1664 2.31926 2.16544 2.32453 2.16454L11.8135 0.544974ZM12.4577 10.5C12.2105 10.5 11.9688 10.4267 11.7632 10.2893C11.5577 10.152 11.3974 9.95676 11.3028 9.72836C11.2082 9.49995 11.1835 9.24861 11.2317 9.00614C11.2799 8.76366 11.399 8.54093 11.5738 8.36612C11.7486 8.1913 11.9713 8.07225 12.2138 8.02402C12.4563 7.97579 12.7076 8.00054 12.936 8.09515C13.1644 8.18976 13.3597 8.34998 13.497 8.55554C13.6344 8.7611 13.7077 9.00277 13.7077 9.25C13.7077 9.58152 13.576 9.89946 13.3416 10.1339C13.1071 10.3683 12.7892 10.5 12.4577 10.5ZM13.2679 3.13591V3.8007L5.08574 3.38403L12.1011 2.18666C12.1064 2.18576 12.1116 2.18481 12.1169 2.18381C12.257 2.1571 12.4014 2.16165 12.5396 2.19714C12.6778 2.23263 12.8064 2.29818 12.9164 2.38912C13.0263 2.48006 13.1148 2.59415 13.1756 2.72323C13.2363 2.85224 13.2679 2.99332 13.2679 3.13591Z"
          fill="white"
        />
      </svg>
    </div>
  );
};
